module.exports = __webpack_public_path__ + "static/img/melani.ac61782.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tools/melani.png
// module id = 455
// module chunks = 1